import classNames from 'classnames';
import {useState} from 'react';

import {Icon} from '@udemy/icons';
import {
    OnePaneLayoutFullWidthSectionContent,
    useContentArea,
    withinOrWiderThan,
} from '@udemy/react-layout-components';
import {Accordion} from '@udemy/react-reveal-components';

import {CategoryNumberIcon} from '../topic-category/topic-category-menu.react-component';
import styles from './section-layout-wrapper.module.less';

type Props = {
    children: React.ReactNode;
    title: string;
    sectionNumber: number | null;
};

export const SectionLayoutWrapper = ({children, title, sectionNumber}: Props) => {
    const isFirstSection = sectionNumber === 1;

    const {range, isRangeKnown} = useContentArea();

    const isMobile = isRangeKnown && !withinOrWiderThan(range, 'md');
    const [isExpanded, setIsExpanded] = useState(isFirstSection);
    if (isMobile) {
        return (
            <Accordion className={styles['section-layout-accordion']} showExpandIcon={false}>
                <Accordion.Panel
                    title={
                        <div className={styles['section-layout-wrapper-title-container']}>
                            <span className={styles['section-layout-wrapper-title-text']}>
                                <CategoryNumberIcon number={sectionNumber} isSmall={true} />
                                {title}
                            </span>
                            <Icon
                                glyph={'expand'}
                                className={classNames(styles['expand-icon'], {
                                    [styles['rotated']]: isExpanded,
                                })}
                                label={false}
                                color="subdued"
                                size={'large'}
                            />
                        </div>
                    }
                    expanded={isExpanded}
                    onToggle={(expanded) => setIsExpanded(expanded)}
                >
                    <OnePaneLayoutFullWidthSectionContent>
                        {children}
                    </OnePaneLayoutFullWidthSectionContent>
                </Accordion.Panel>
            </Accordion>
        );
    }
    return <OnePaneLayoutFullWidthSectionContent>{children}</OnePaneLayoutFullWidthSectionContent>;
};
